import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { debugModeArgument } from "utils/debugModeArgument";

/**
 * Atom for result information
 * */
const ResultInfo = ({
  className,
  count,
  isSizeSmall,
  preposition = "für",
  resultsText = "Ergebnisse",
  resultText = "Ergebnis",
  searchTerm,
  showCount = false,
  showPreposition = false,
}) => {
  const componentBaseClass = "sal-result-info";
  const componentClassName = classnames(
    componentBaseClass,
    {
      [`${componentBaseClass}--size-small`]: isSizeSmall,
    },
    className,
  );

  const rText = count === 1 ? resultText : resultsText;
  let forTerm = "";

  if (searchTerm) {
    forTerm = (
      <span className={componentBaseClass + "__for-term"}>
        {showPreposition && preposition}{" "}
        <strong className={componentBaseClass + "__search-term"}>
          &bdquo;{searchTerm}&ldquo;
        </strong>
      </span>
    );
  }
  return (
    <span
      className={componentClassName}
      data-cv-debug={debugModeArgument("true")}
      data-cv-debug-system={debugModeArgument("SAL")}
      data-cv-debug-component={debugModeArgument("SearchResultFeedback")}
    >
      {showCount && count} {rText} {forTerm}
    </span>
  );
};

ResultInfo.propTypes = {
  count: PropTypes.number.isRequired,
  resultsText: PropTypes.string.isRequired,
  resultText: PropTypes.string.isRequired,
  searchTerm: PropTypes.string,
  preposition: PropTypes.string,
  className: PropTypes.string,
  isSizeSmall: PropTypes.bool,
  showCount: PropTypes.bool,
  showPreposition: PropTypes.bool,
};

export default ResultInfo;
